import logo from './logo.svg';
import './App.css';
import Header from './Componants/Header';
import Benner from './Componants/Benner';
import Fotter from './Componants/Fotter';

function App() {
  return (
    <>
      <Header/>
      <Benner/>
      <Fotter/>
    </>

  );
}

export default App;
